export const PERKS_ADMIN_SLICE_NAME = "perksAdmin"
